<template>
  <v-app-bar app id="appBar" color="white" class="headerApp">
    <CustomRow>
      <div class="d-flex align-center">
        <div role="button" class="nav-item brand">
          <v-img @click="toIndex" src="@/assets/image/ticketplus-logo.svg" max-height="50px" max-width="100px"
            role="button" contain />
        </div>
        <template v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm">
          <div role="button" class="nav-item" @click="toAbout">{{ $t('nav_about') }}</div>
          <div role="button" class="nav-item" @click="toFAQ">{{ $t('nav_faq') }}</div>
          <div role="button" class="nav-item" @click="toMember">{{ $t('nav_member') }}</div>
          <v-spacer></v-spacer>
          <v-btn rounded outlined depressed color="primary-1" @click="clickLogin" v-if="!$store.state.user.access_token">
            <v-icon>mdi-account</v-icon>
            {{ $t('nav_login') }}
          </v-btn>
          <div class="font-weight-bold" v-else>
            {{ $store.state.user.account }}
            <span role="button" class="primary-1--text ml-3 cursor-pointer" @click="clickLogout">{{ $t('nav_logout')
            }}</span>
          </div>
          <v-divider :vertical="true" color="primary-1" width="2" class="mx-4 my-4" />
          <MultiLangSelectorVue />
        </template>
        <template v-else>
          <v-spacer />
          <v-icon color="primary-1" @click="toggleDrawer">mdi-menu</v-icon>
        </template>
      </div>
    </CustomRow>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MultiLangSelectorVue from "../components/MultiLangSelector.vue";
export default {
  name: "TheLayoutToolbar",
  components: { MultiLangSelectorVue },
  data() {
    return {
      currentLocation: "",
    };
  },
  computed: {
    ...mapGetters({
      needRelogin: "login/relogin",
    }),
  },
  watch: {
    needRelogin: {
      deep: true,
      handler: function (newVal, old) {
        if (newVal !== old && newVal) {
          this.clickLogin();
        }
      },
    },
  },
  mounted() {
    if (this.needRelogin) {
      this.clickLogin();
    }
  },
  methods: {
    ...mapActions({
      setRelogin: "login/relogin",
      showLogin: "login/show",
      logout: "user/logoutToIndex",
    }),
    toIndex() {
      this.$router.push({ name: "Index" }).catch(() => { });
    },
    toggleDrawer() {
      this.$store.dispatch("DrawerToggle");
    },
    toAbout(e) {
      this.$router.push({ name: "About" }).catch(() => { });
    },
    toFAQ(e) {
      this.$router.push({ name: "FAQ" }).catch(() => { });
    },
    toMember(e) {
      this.$router.push({ name: "Member" }).catch(() => { });
    },
    clickLogin(e) {
      this.showLogin();
    },
    clickLogout(e) {
      this.logout();
    },
  },
};
</script>

<style lang="scss" scoped>
#appBar.headerApp {
  z-index: 6;
  box-shadow: $shadow;

  .nav-item:not(.brand) {
    margin-left: 40px;
    color: $grey-darken-3;
  }
}

::v-deep .v-toolbar__content {
  padding: 4px 0px;
}
</style>
